<template>
  <div style="display: grid; grid-template-columns: repeat(2, 4em);">
    <div>
      <vue-scroll :ops="ops">
        <div style="position: absolute; width: 100%;">
          <div
            v-for="hour in displayHours"
            :key="`hour-${hour.display}`"
            class="hour"
            :class="{ 'hour--selected': hour.selected }"
            style="margin-right: 1em;"
            @click="onHour($event, { hour: hour.value })"
          >
            <div class="hour__text" :class="{ 'hour__text--selected': hour.selected }">{{ hour.display }}</div>
          </div>
        </div>
      </vue-scroll>
    </div>
    <div>
      <vue-scroll :ops="ops">
        <div style="position: absolute; width: 100%;">
          <div
            v-for="minute in displayMinutes"
            :key="`minute-${minute.display}`"
            class="minute"
            :class="{ 'minute--selected': minute.selected }"
            style="margin-right: 1em;"
            @click="onMinute($event, { minute: minute.value })"
          >
            <div class="minute__text" :class="{ 'minute__text--selected': minute.selected }">{{ minute.display }}</div>
          </div>
        </div>
      </vue-scroll>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VueScroll from 'vuescroll'

export default {
  components: {
    VueScroll
  },
  model: {
    event: 'change'
  },
  props: {
    value: {
      type: [String, Object],
      required: false,
      default: null
    },
    range: {
      type: Boolean,
      required: false,
      default: false
    },
    isEnd: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    ops: {}
  }),
  computed: {
    selectedValue() {
      const { value } = this

      if (this.range) {
        if (value) {
          return this.isEnd ? value.end : value.start
        } else {
          return null
        }
      } else {
        return value
      }
    },
    displayHours() {
      const hours = []

      for (let i = 0; i < 24; i++) {
        const selected = (moment(this.selectedValue).hour() === i)

        hours.push({
          value: i,
          display: i.toString().padStart(2, '0'),
          selected
        })
      }

      return hours
    },
    displayMinutes() {
      const minutes = []

      for (let i = 0; i < 60; i++) {
        const selected = (moment(this.selectedValue).minute() === i)

        minutes.push({
          value: i,
          display: i.toString().padStart(2, '0'),
          selected
        })
      }

      return minutes
    }
  },
  created() {
    this.ops = {
      rail: {
        opacity: '1',
        background: '#f5f5f5'
      },
      bar: {
        background: '#999',
        keepShow: true
      }
    }
  },
  methods: {
    onHour(event, payload) {
      const { hour } = payload
      let value = null

      if (this.selectedValue) {
        value = moment(this.selectedValue).hour(hour).format()
      } else {
        value = moment().hour(hour).minute(0).second(0).millisecond(0).format()
      }

      const { value: dataValue } = this

      if (this.range) {
        const object = dataValue ? { start: dataValue.start, end: dataValue.end } : { start: null, end: null }
        const key = this.isEnd ? 'end' : 'start'
        object[key] = value
        this.$emit('change', object)
      } else {
        this.$emit('change', value)
      }
    },
    onMinute(event, payload) {
      const { minute } = payload
      let value = null

      if (this.selectedValue) {
        value = moment(this.selectedValue).minute(minute).format()
      } else {
        value = moment().hour(0).minute(minute).second(0).millisecond(0).format()
      }

      const { value: dataValue } = this

      if (this.range) {
        const object = dataValue ? { start: dataValue.start, end: dataValue.end } : { start: null, end: null }
        this.$emit('change', object)
      } else {
        this.$emit('change', value)
      }
    }
  }
}
</script>

<style scoped>
.hour {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.75em;
  font-size: 0.75em;
  border-radius: 0.125em;
  cursor: pointer;
}

.hour:hover {
  background-color: #ebf8ff;
  color: #2b6cb0;
}

.hour--selected {
  font-weight: bold;
}

.hour__text {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5em;
  height: 2.5em;
  border-radius: 50%;
}

.hour__text--selected {
  background-color: #1f65b5;
  color: #e6fffa;
}

.minute {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.75em;
  font-size: 0.75em;
  border-radius: 0.125em;
  cursor: pointer;
}

.minute:hover {
  background-color: #ebf8ff;
  color: #2b6cb0;
}

.minute--selected {
  font-weight: bold;
}

.minute__text {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5em;
  height: 2.5em;
  border-radius: 50%;
}

.minute__text--selected {
  background-color: #1f65b5;
  color: #e6fffa;
}
</style>
